import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import ChatAttachment from './ChatAttachment';
import ChatMessageLabel from './ChatMessageLabel';
import ChatText from './ChatText';
import { messageDate } from './utils';

const UserAvatar = (user, side, newMessage) => {
  let initialStyles = {};
  const { avatar, initials } = user;
  if (avatar) {
    initialStyles = {
      backgroundImage: `url(${avatar})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '0% 0%',
      backgroundSize: 'cover',
    };
  }
  return (
    <div style={initialStyles} className={cn('chat-list_avatar', side)}>
      {!avatar && <span>{initials}</span>}
      <div className={cn('new-message-badge', { '-new-message': newMessage })} />
    </div>
  );
};

const ChatMessage = ({ message, labels, onAttachmentClick, role, hideInitials }) => {
  const side =
    role === 'customer'
      ? message.customer_message
        ? '-to'
        : '-from'
      : message.customer_message
        ? '-from'
        : '-to';
  const messageSide =
    role === 'customer'
      ? message.customer_message
        ? '-left'
        : '-right'
      : message.customer_message
        ? '-right'
        : '-left';
  const label = labels.find(i => i.id === message.id);
  const background = {
    '-highlighted': message.highlighted,
  };
  const messageStyles = cn('chat-list_message', side, background);
  // const dateStyles = cn('chat-list_date', side);
  const { user, text, images } = message;
  const unread = !message.seen;
  return (
    <Fragment>
      {label && (
        <div className={cn('chat-list_line-wrapper')} timestamp={message.timestamp}>
          <ChatMessageLabel label={label.text} />
        </div>
      )}
      <div
        className={cn('chat-list_line-wrapper', { '-message-unread': unread })}
        timestamp={message.timestamp}
        message_id={message.id}
      >
        <div className={cn('chat-list_message-wrapper', messageSide)}>
          <div className="chat-list_message-body">
            {!hideInitials && UserAvatar(user, side, !message.seen)}
            {!hideInitials && (
              <div className="chat-list_message-author">
                {user.full_name}
                <div className="chat-list_message-time">{message.created_at_time}</div>
              </div>
            )}
            <div className={messageStyles}>
              {text && <ChatText text={text} />}
              {images.map((image, index) => (
                <ChatAttachment key={index} file={image} onClick={onAttachmentClick} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

ChatMessage.propTypes = {
  message: PropTypes.shape({}).isRequired,
  labels: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onAttachmentClick: PropTypes.func.isRequired,
};

export default React.memo(ChatMessage);



// WEBPACK FOOTER //
// ./app/javascript/common/components/ChatMessage/ChatMessage.js